const validate = (values) => {
  const attrs = values || {};
  const errors = {};
  if (!attrs.email) {
    errors.email = 'Debe ingresar el correo electrónico.';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(attrs.email)) {
    errors.email = 'El correo electronico no es valido.';
  }
  if (!attrs.password) {
    errors.password = 'Debe ingresar la contraseña';
  }
  errors.isValid = Object.keys(errors).length === 0;

  return errors;
};

export default validate;
